import {Component} from '@angular/core';


@Component({
    selector: 'app-medical-help',

    templateUrl: './medical-help.component.html',
    styleUrl: './medical-help.component.css'
})
export class MedicalHelpComponent {


}



